(ns superadmin.roles.ui
  (:require ["@mui/material/Chip$default" :as Chip]
            [uix.core :refer [defui $]]))

(defui permission-chip [{:keys [label selected onToggle auto-selected]}]
  ($ Chip
     {:label label
      :size "small"
      :variant (if (or selected auto-selected) "filled" "outlined")
      :color (if auto-selected "warning" "primary")
      :onClick onToggle
      :sx #js {:cursor "pointer"
               :minWidth 80}}))